import { render, staticRenderFns } from "./units.vue?vue&type=template&id=20d776d9&scoped=true"
import script from "./units.vue?vue&type=script&lang=js"
export * from "./units.vue?vue&type=script&lang=js"
import style0 from "./units.vue?vue&type=style&index=0&id=20d776d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d776d9",
  null
  
)

export default component.exports